import PivotTableUI, { DraggableAttribute } from "react-pivottable/PivotTableUI";

let patched = false;

if (!patched && DraggableAttribute?.prototype) {
  patched = true;

  const originalToggleValue = DraggableAttribute.prototype.toggleValue;
  const originalSelectOnly = DraggableAttribute.prototype.selectOnly;
  const originalMatchesFilter = DraggableAttribute.prototype.matchesFilter;
  const originalGetFilterBox = DraggableAttribute.prototype.getFilterBox;
  const originalRender = DraggableAttribute.prototype.render;

  const makeSafeInstance = (instance) => {
    const safeInstance = Object.create(instance);
    safeInstance.props = {
      ...instance.props,
      attrValues: instance.props?.attrValues || {},
      valueFilter: instance.props?.valueFilter || {},
    };
    return safeInstance;
  };

  DraggableAttribute.prototype.toggleValue = function toggleValue(value) {
    return originalToggleValue.call(makeSafeInstance(this), value);
  };

  DraggableAttribute.prototype.selectOnly = function selectOnly(e, value) {
    return originalSelectOnly.call(makeSafeInstance(this), e, value);
  };

  DraggableAttribute.prototype.matchesFilter = function matchesFilter(value) {
    return originalMatchesFilter.call(this, String(value == null ? "" : value));
  };

  DraggableAttribute.prototype.getFilterBox = function getFilterBox() {
    return originalGetFilterBox.call(makeSafeInstance(this));
  };

  DraggableAttribute.prototype.render = function render() {
    return originalRender.call(makeSafeInstance(this));
  };
}

export default PivotTableUI;
